import React, { PropsWithChildren } from 'react';
import { useQueryRouter } from '@guest-widgets/shared/src/components/Router/QueryRouter';
import { useProducts } from '@guest-widgets/catalog/src/App/productsContext';

interface QueryLinkProps {
  query: Record<string, string>;
  className?: string;
  onClick?: () => void;
}

// inspired by https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/modules/Link.js
export const QueryLink = ({
  query,
  className,
  onClick: onLinkClick,
  children,
}: PropsWithChildren<QueryLinkProps>) => {
  const { set, getUrl } = useQueryRouter();
  const entries = Object.entries(query);

  let href = entries.reduce((acc, [key, val]) => getUrl(key, val), window.location.href);

  const onClick = (event: React.MouseEvent) => {
    if (
      event.button === 0 && // ignore everything but left clicks
      !isModifiedEvent(event) // ignore clicks with modifier keys
    ) {
      onLinkClick?.();
      event.preventDefault();
      for (const [key, val] of entries) {
        set(key, val);
      }
    }
  };

  return (
    <a className={className} href={href} onClick={onClick}>
      {children}
    </a>
  );
};

function isModifiedEvent(event: React.MouseEvent) {
  return event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
}
